module.exports = __webpack_public_path__ + "img/DE00951.89c901d3.png";